<template>
  <button
    :class="[
      ' px-4 py-2 transition duration-300',
      active ? 'bg-[#4F4F51] text-white' : 'bg-white text-[#4F4F51]',
    ]"
    @click="clickFunction(view)"
  >
    <!-- <component :is="icon" /> -->
    <slot />
  </button>
</template>

<script>
export default {
  props: ["clickFunction", "view", "exisingView"],
  computed: {
    active() {
      return this.view === this.exisingView;
    },
  },
};
</script>

<style>
</style>